// extracted by mini-css-extract-plugin
export default {"container":"V28Yj6UNP6dMex7uhuVP"};